import React from 'react';
import Navbar from '../../components/landingPageComponent/Navbar';
import BusinessSupportCmpt from '../../components/landingPageComponent/BusinessSupportCmpt';
import Footer from '../../components/landingPageComponent/Footer'; 
import ScrollTop from '../../components/landingPageComponent/ScrollTop'

const BusinessSupport = () => {
	return (
		<div className='overflow-hidden'>
      <Navbar />
      <BusinessSupportCmpt />
			<Footer />
			<ScrollTop />
		</div>
	);
};

export default BusinessSupport;
